import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { numberWithCommas } from "../../../../utils/utils";

const Card = ({ imgSrc = "", content = "", statistics = "" }) => {
  const { isXss, theme } = useCustomLogic();

  return (
    <Box
      sx={{
        borderBottomRightRadius: ".2rem",
        borderBottomLeftRadius: ".2rem",
        boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
        display: "flex",
        flexDirection: isXss && "column",
        justifyContent: "flex-start",
        alignTtems: "center",
        padding: "5px 0px",
        cursor: "pointer",
        gap: "10px",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 0.5rem 2rem #D8DFED",
          opacity: 1,
        },
      }}
    >
      <img src={imgSrc} />

      <Box
        sx={{
          paddingTop: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          alignItems: isXss && "center",
          marginLeft: isXss && "0",
          marginTop: isXss && "10px",
        }}
      >
        <Typography variant="subheading3" style={{ fontSize: "16px", color: "#6C757D" }}>
          {content}
        </Typography>
        <Typography
          style={{
            color: theme.palette.primary.dark,
            fontWeight: "Lato",
            fontFamily: "400",
            fontSize: "32px",
            wordBreak: "break-all",
          }}
        >
          {numberWithCommas(statistics)}
        </Typography>
      </Box>
    </Box>
  );
};

export default Card;
